import React from "react";
import { DEFAULT_DEBOUNCE_TIMEOUT } from "consts";
import { getLocations } from "api";
//
import { AutoSuggest } from "containers/components/autoSuggest";

const DomainAutoSuggest = (props) => {
    const suggestDomain = (q) => {
        if (q) {
            q = q.toLocaleLowerCase();
        }

        return Promise.resolve(
            getLocations().then((data) => {
                return data
                    .filter((location) => (location.domain || "")
                        .toLocaleLowerCase()
                        .includes(q)
                    );
            })
        );
    };

    return (
        <AutoSuggest
            label="Domain"
            fetchOptions={(q) => suggestDomain(q)}
            renderOption={(location) => ({ value: location, label: location.domain })}
            optionIdentifier={(location) => location.domain}
            debounceTimeout={DEFAULT_DEBOUNCE_TIMEOUT}
            {...props}
        />
    );
};

export default DomainAutoSuggest;
